// 
import { normalizeUrl } from '../lib/urlAndLink';
import Uri from 'urijs';
import {
  getDynamicAreaIdWithoutContext,
  parsePartialUpdateSettingsFromUrl,
} from './partialUpdateUtils';
import { execute } from './partialUpdate';
import { getGlobalPartialUpdateSettings } from './PartialUpdateSettings';

let lastExecutedUrl;

/**
 * Připojí
 */
export default () => {
  const {
    globalTarget,
  } = getGlobalPartialUpdateSettings();
  if (!lastExecutedUrl) {
    lastExecutedUrl = window.location.href;
  }
  // let lastPartialUpdateTarget = null;
  // pomocí historyStatePageNumber lze zjistit jakým směrem se uživatel v historii pohybuje
  let historyStatePageNumber = (
    window.history.state && window.history.state.pageNumber
  ) ? window.history.state.pageNumber : 0;

  window.addEventListener('popstate', (event) => {
    let url = new Uri(normalizeUrl(window.location.href));
    lastExecutedUrl = new Uri(normalizeUrl(lastExecutedUrl));
    lastExecutedUrl = lastExecutedUrl.toString();

    if (window.history.state && window.history.state.partialUpdate) {
      const settings = window.history.state && window.history.state.puSettings ?
        window.history.state.puSettings : {};

      const { target } = settings;

      if (lastExecutedUrl !== url.toString()) {
        const pageNumber = (
          event.state && event.state.pageNumber
        ) ? event.state.pageNumber : 0;
        let direction = 'next';
        if (pageNumber < historyStatePageNumber) {
          direction = 'prev';
        }
        historyStatePageNumber = pageNumber;
        execute({
          target: target || globalTarget,
          url: url.toString(),
          historyPopState: true,
          historyDirection: direction,
        });
      }
    }
  });

  const puSettings = parsePartialUpdateSettingsFromUrl(window.location.href);
  if (puSettings) {
    execute(puSettings);
    // lastPartialUpdateTarget = puSettings.target;
  }

  const handlePartialUpdateHistory = (settings, alterHistoryUrl) => {
    if (settings.alterHistory && alterHistoryUrl && alterHistoryUrl !== '') {
      const url = normalizeUrl(window.location.href);
      let frameUri = new Uri(url || '');

      const {
        target,
        containerId,
        requestTarget,
        historyReplaceState,
        historyPopState,
      } = settings;

      const targetWithoutContext = (
        target || containerId
      ) ? getDynamicAreaIdWithoutContext(target || containerId) : null;
      const requestTargetWithoutContext = requestTarget && getDynamicAreaIdWithoutContext(
        requestTarget);

      let replaceState = false;
      if (requestTargetWithoutContext && requestTargetWithoutContext === globalTarget && requestTargetWithoutContext !== targetWithoutContext) {
        frameUri.setQuery('pu', JSON.stringify({
          requestTarget: requestTargetWithoutContext,
          target: targetWithoutContext,
          url: alterHistoryUrl,
        }));
      } else {
        frameUri = new Uri(alterHistoryUrl);
        replaceState = historyReplaceState;
      }

      if (!historyPopState && url !== frameUri.toString()) {

        // do stavu historie se mohou pushovat pouze primitivní typy
        let settingsForState = {};
        Object.keys(settings).forEach((key) => {
          const property = settings[key];
          if (
            typeof property === 'boolean' ||
            typeof property === 'string' ||
            Array.isArray(property) ||
            (
              typeof property !== 'function' &&
              typeof property === 'object'

            )
          ) {
            settingsForState[key] = property;
          }
        });

        if (replaceState) {
          // s replacem se pageNumber nemění
          window.history.replaceState(
            {
              partialUpdate: true,
              pageNumber: historyStatePageNumber,
              puSettings: settingsForState
            },
            undefined,
            frameUri.toString(),
          );
        } else {
          // pro push se historyStatePageNumber incrementuje;
          historyStatePageNumber = historyStatePageNumber + 1;

          // pokud ještě nebzl do historie udělaný push nebo replace,
          // tak se poprvé do něj replacne, abz se do historz state uložilo pu setting
          // a při návratu se načetl target při kterém byla stránka opouštěna
          if (!(window.history.state && window.history.state.partialUpdate)) {
            window.history.replaceState(
              {
                partialUpdate: true,
                pageNumber: 0,
                puSettings: settingsForState,
              },
              undefined,
            );
          }

          window.history.pushState(
            {
              partialUpdate: true,
              pageNumber: historyStatePageNumber,
              puSettings: settingsForState,
            },
            undefined,
            frameUri.toString()
          );
        }
      }
      lastExecutedUrl = frameUri.toString();
    }
  };

  document.addEventListener('partialUpdateComplete', (e) => {
    const {
      detail: {
        alterHistoryUrl,
        settings,
      },
    } = e;

    if (alterHistoryUrl) {
      handlePartialUpdateHistory(settings, alterHistoryUrl);
    } else {
      lastExecutedUrl = window.location.href;
    }
  });
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/partialUpdate/connectHistory.js